import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class SettingTypeService {
  private settingTypesURL = 'setting_types';

  constructor(private httpClient: HttpClientService) {}

  getSettingTypes(settingGroupId: number, data: any): Promise<any> {
    data.setting_group_id = settingGroupId;
    return this.httpClient.get(`${this.settingTypesURL}.json`, data).catch(function () {});
  }

  createSettingType(settingGroupId: number, data: any): Promise<any> {
    data.setting_group_id = settingGroupId;
    return this.httpClient.post(`${this.settingTypesURL}.json`, data).catch(function () {});
  }

  updateSettingType(settingGroupId: number, settingTypeId: number, data: any): Promise<any> {
    data.setting_group_id = settingGroupId;
    return this.httpClient.put(`${this.settingTypesURL}/${settingTypeId}.json`, data).catch(function () {});
  }

  getSettingType(settingTypeId: number): Promise<any> {
    return this.httpClient.get(`${this.settingTypesURL}/${settingTypeId}.json`).catch(function () {});
  }

  deleteSettingType(settingTypeId: number): Promise<any> {
    return this.httpClient.delete(this.settingTypesURL + '/' + settingTypeId + '.json').catch(function () {});
  }
}
